module.exports = __webpack_public_path__ + "img/s2P19.2f9e610d.png";